import { ActivatedRoute, Router } from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { Injectable } from '@angular/core';

import { UrlMappingService } from './url-mapping.service';

@Injectable({
  providedIn: 'root'
})
export class PaginationComponentService {
  constructor(private route: ActivatedRoute, private router: Router, private urlMappingService: UrlMappingService) {}

  getUrlWithParams(): Observable<string> {
    const url = this.router.createUrlTree([], {
      relativeTo: this.route,
      queryParams: {
        page: null
      }
    });
    let linkUrl = this.router.serializeUrl(url);
    return this.urlMappingService.getUrlMappingByCode(linkUrl).pipe(
      take(1),
      map((result) => {
        if (result) {
          linkUrl = linkUrl.replace(result.code, result.value);
        }
        return linkUrl.includes('?') ? linkUrl + '&page=' : linkUrl + '?page=';
      })
    );
  }
}
